/** Route-guard decision table for `Protected` in App.js, pulled out as a pure function so the
 * cross-portal role-exclusion rules (2026-09, Bavna #24 defense-in-depth fix) have a permanent,
 * fast, no-browser-needed unit test — see computeProtectedRedirect.test.js.
 *
 * Returns a redirect path string if the given user/flags combination should NOT see `children`,
 * or `null` if access is allowed. Callers must handle `loading`/`!user` separately (kept in
 * App.js — those aren't part of the role-exclusion regression this file guards against).
 */
export const STAFF_ONLY_ROLES = ["founder", "partner", "pm", "coordinator", "finance", "creative", "guest"];

export function computeProtectedRedirect(user, { staffOnly, clientPortal, partnerPortal, agencyPortal, communityMember } = {}) {
  // Freelancer/Production Partner/Client/Partner Agency each have their own dedicated portal
  // shells (never AppShell — none hold any of the internal staff module scopes AppShell's nav
  // is built from). Every non-staff role MUST have an explicit exclusion here — a missing one
  // is exactly how role="partner_agency" slipped through staffOnly before the 2026-09 fix.
  if (staffOnly && user.role === "freelancer") return "/build/me";
  if (staffOnly && user.role === "production_partner") return "/partner/me";
  if (staffOnly && user.role === "client") return "/client-portal/home";
  if (staffOnly && user.role === "partner_agency") return "/agency";
  if (clientPortal && user.role !== "client") return "/";
  if (communityMember && !(STAFF_ONLY_ROLES.includes(user.role) || user.role === "freelancer")) return "/";
  if (partnerPortal && user.role !== "production_partner") return "/";
  if (agencyPortal && user.role !== "partner_agency") return "/";
  return null;
}
